import React, { useEffect, useRef, useState } from "react";
import logo from "../../../../assets/images/logo.png";
import { Button, Form, Input, Select } from "antd";
import notificationHandler from "../../../atoms/Notification";
import { useDispatch } from "react-redux";
import { getOtp, getToken, setPhoneNumber } from "./slice";
import { AppDispatch } from "../../../../app/store";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import "./login.scss";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { SsoURL } from "../../../../configs/constant";
type Props = {};

const LoginPage = (props: Props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showSsoOption, setShowSsoOption] = useState(false);
  const [mobileLoginOption, setMobileLoginOption] = useState<"mobileId" | "otp">("mobileId");
  const [otp, setOtp] = useState(false);
  const [countdownTime, setCountdownTime] = useState(30);
  const [phone, setPhone] = useState("");
  const fpPromise = FingerprintJS.load();
  const autoOtpRequested = useRef(false);

  const normalizePhoneNumber = (value: string) => {
    const digitsOnly = `${value || ""}`.replace(/\D/g, "");

    if (!digitsOnly) {
      return "";
    }

    if (digitsOnly.startsWith("84")) {
      const localPart = digitsOnly.slice(2).replace(/^0+/, "");
      return localPart ? `0${localPart}` : "";
    }

    if (digitsOnly.startsWith("0")) {
      return `0${digitsOnly.slice(1)}`;
    }

    return digitsOnly.length === 9 ? `0${digitsOnly}` : digitsOnly;
  };

  const normalizeMsisdn = (value: string) => {
    const normalizedPhone = normalizePhoneNumber(value);

    if (!normalizedPhone) {
      return "";
    }

    return `84${normalizedPhone.slice(1)}`;
  };

  const handlePvnLogin = async () => {
    try {
      const values = await form.validateFields(["phoneNumber"]);
      const phoneNumber = normalizePhoneNumber(values.phoneNumber || "");
      const oauthEndpoint = process.env.REACT_APP_OAUTH_ENDPOINT || "";
      const clientUri = process.env.REACT_APP_CLIENT_URI || "";

      if (!phoneNumber) {
        notificationHandler("error", "Vui lòng nhập số điện thoại!");
        return;
      }
      if (!oauthEndpoint || !clientUri) {
        notificationHandler(
          "error",
          "Thiếu cấu hình OAuth, vui lòng kiểm tra .env"
        );
        return;
      }

      dispatch(setPhoneNumber(phoneNumber));
      const msisdn = normalizeMsisdn(phoneNumber);
      const baseClientUri = clientUri.replace(/\/$/, "");
      const redirectUri = `${baseClientUri}/authcallback`;
      const serviceUri = `${baseClientUri}/`;
      const redirectUrl = `${oauthEndpoint.replace(/\/$/, "")}/redirect`;
      const url = new URL(redirectUrl);
      url.searchParams.set("msisdn", msisdn);
      url.searchParams.set("redirect_uri", redirectUri);
      url.searchParams.set("scope", "PHONE_VERIFY");
      url.searchParams.set("account_id", "2");
      url.searchParams.set("client", "viettel-app");
      url.searchParams.set("service_uri", serviceUri);
      console.log(url.toString());
      window.location.assign(url.toString());
    } catch (error) {
      notificationHandler("error", "Vui lòng nhập số điện thoại hợp lệ");
    }
  };

  const isMobileViewport = () =>
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(max-width: 480px)").matches;

  const handleLogin = async (values: any) => {
    if (isMobileViewport() && mobileLoginOption === "mobileId") {
      handlePvnLogin();
      return;
    }
    const normalizedPhone = normalizePhoneNumber((values.phoneNumber as string) || "");
    dispatch(setPhoneNumber(normalizedPhone));
    if (values) {
      if (normalizedPhone && values.otp) {
        getTokenLogin(normalizedPhone, values.otp);
      } else {
        setPhone(normalizedPhone);
        getOtpLogin(normalizedPhone);
      }
    }
  };

  const getOtpLogin = async (phone: string) => {
    dispatch(getOtp(phone))
      .unwrap()
      .then((value: any) => {
        if (!value.success) {
          notificationHandler("error", value.payload.data.msg_content);
        } else {
          setOtp(true);
          setCountdownTime(30);
          notificationHandler("success", "Gửi mã OTP thành công!");
        }
      })
      .catch((error) => {
        notificationHandler("error", error.response?.data?.data?.msg_content);
      });
  };

  useEffect(() => {
    const showOtp = searchParams.get("showOtp");
    const phoneParam = searchParams.get("phone");
    if (!showOtp || !phoneParam || autoOtpRequested.current) {
      return;
    }
    if (isMobileViewport()) {
      return;
    }
    autoOtpRequested.current = true;
    const trimmedPhone = phoneParam.trim();
    form.setFieldValue("phoneNumber", trimmedPhone);
    getOtpLogin(trimmedPhone);
  }, [searchParams, form]);

  const getTokenLogin = async (phoneNumber: string, otp: string) => {
    const fp = await fpPromise;
    const result = await fp.get();
    const ip = result.visitorId;

    dispatch(getToken({ phoneNumber, otp, ip }))
      .then((value: any) => {
        if (!value.payload.success) {
          notificationHandler(
            "error",
            value.payload.response.data.data.msg_content
          );
        } else {
          notificationHandler("success", "Đăng nhập thành công");
          navigate("/order-meals");
        }
      })
      .catch((error) => {
        notificationHandler("error", "Đăng nhập không thành công");
        throw error;
      });
  };

  const validatePhoneNumber = (_: any, value: any) => {
    const normalizedPhone = normalizePhoneNumber(value || "");

    if (!normalizedPhone) {
      return Promise.reject("Vui lòng nhập số điện thoại!");
    }

    const phoneNumberRegex = /^0\d{9}$/;
    if (!phoneNumberRegex.test(normalizedPhone)) {
      return Promise.reject("Số điện thoại không hợp lệ , vui lòng thử lại!");
    }
    return Promise.resolve();
  };

  const validateOtpCode = (_: any, value: any) => {
    if (!value) {
      return Promise.reject("Vui lòng nhập mã OTP!");
    }
    const phoneNumberRegex = /^[0-9]+$/;
    if (!phoneNumberRegex.test(value)) {
      return Promise.reject("Mã OTP không hợp lệ , vui lòng thử lại!");
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (countdownTime === 0) {
        clearInterval(countdownInterval);
      } else {
        setCountdownTime((prevTime) => prevTime - 1);
      }
    }, 1000);
    return () => clearInterval(countdownInterval);
  }, []);

  useEffect(() => {
    setShowSsoOption(Boolean(searchParams.get("showSso")));
  }, [searchParams]);

  return (
    <div className="flex h-screen  bg-login ">
      <div className="m-auto p-[24px] bg-[#EFF0F1] rounded-[16px] w-[480px] max-[480px]:w-11/12   ">
        <div>
          <div>
            <img className="m-auto" src={logo} alt="" />
          </div>
          <div className="flex flex-col items-center p-[24px_0]">
            <h1 className="min-[480px]:text-[32px] text-[24px] font-bold uppercase mb-[13px]">
              Đăng nhập
            </h1>
            <small className="text-grayColor7 text-base">Bếp ăn Viettel</small>
          </div>
          <div>
            <Form onFinish={handleLogin} form={form} layout={"vertical"}>
              <div className="mb-4">
                <label className="block text-sm  mb-2">
                  Số điện thoại (Viettel)
                </label>
                <Form.Item
                  name="phoneNumber"
                  rules={[
                    {
                      validator: validatePhoneNumber,
                    },
                  ]}
                >
                  <Input
                    placeholder="Nhập số điện thoại"
                    prefix={<UserOutlined />}
                    maxLength={13}
                    className="w-full rounded-[8px] focus:outline-none border border-[#727986]"
                    disabled={otp ? true : false}
                    onBlur={(e) => {
                      form.setFieldValue(
                        "phoneNumber",
                        normalizePhoneNumber(e.target.value)
                      );
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    type="phone"
                  />
                </Form.Item>
                {otp && (
                  <div className={`login-desktop-only${(showSsoOption || mobileLoginOption === "otp") ? " login-otp-visible" : ""}`}>
                    <label className="block text-sm text-[16px] mb-2">
                      Mã xác thực OTP
                    </label>
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          validator: validateOtpCode,
                        },
                      ]}
                      className="mb-1"
                    >
                      <Input
                        prefix={<LockOutlined />}
                        maxLength={6}
                        placeholder="Nhập mã OTP"
                        className="w-full rounded-[8px] focus:outline-none border border-[#727986]"
                        onBlur={(e) =>
                          form.setFieldValue("otp", e.target.value.trim())
                        }
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <div className="mt-1 grid gap-1 grid-cols-2">
                        <div className="text-[16px]">
                          Không nhận được mã OTP?
                        </div>
                        <div className="grid justify-items-end">
                          <span
                            className={`${countdownTime > 0
                              ? "cursor-not-allowed"
                              : "cursor-pointer hover:underline"
                              } text-[16px]`}
                            onClick={() => {
                              if (countdownTime >= 0) {
                                return false;
                              } else {
                                getOtpLogin(phone)
                                  .then((res: any) => {
                                    if (res?.data?.success) {
                                      notificationHandler(
                                        "success",
                                        `Mã OTP đã được gửi đến số điện thoại của quý khách.
                                Vui lòng kiểm tra`
                                      );
                                    }
                                    setCountdownTime(30);
                                  })
                                  .catch((reason: any) => {
                                    if (reason.response?.data?.data) {
                                      notificationHandler(
                                        "error",
                                        reason.response?.data?.data?.msg_content
                                      );
                                    }
                                  });
                              }
                            }}
                          >
                            Gửi lại mã OTP{" "}
                            <span className="text-primary font-bold">
                              ({countdownTime >= 0 ? countdownTime : 0})
                            </span>
                          </span>
                        </div>
                      </div>
                    </Form.Item>
                  </div>
                )}
              </div>
              <div>
                <div className="mb-4 login-mobile-only">
                  <label className="block text-sm mb-2">
                    Hình thức đăng nhập
                  </label>
                  <Select
                    value={mobileLoginOption}
                    onChange={(value) => setMobileLoginOption(value)}
                    className="w-full text-left custom-select-mobile"
                    options={[
                      { value: "mobileId", label: "Đăng nhập bằng MobileID" },
                      { value: "otp", label: "Đăng nhập bằng OTP" },
                    ]}
                  />
                </div>
                <Form.Item className="mb-2 login-mobile-only">
                  <Button
                    htmlType={mobileLoginOption === "otp" ? "submit" : "button"}
                    onClick={mobileLoginOption === "mobileId" ? handlePvnLogin : undefined}
                    className="mx-auto w-full p-[16px] bg-white rounded-[10px] font-semibold text-primary hover:border-primary hover:text-primary focus:border-primary focus:text-primary flex items-center justify-center h-[48px]"
                  >
                    Đăng nhập
                  </Button>
                </Form.Item>
                <Form.Item className="mb-2 login-desktop-only">
                  <Button
                    htmlType="submit"
                    className="mx-auto w-full  p-[16px] bg-white rounded-[10px] font-semibold text-primary  hover:border-primary hover:text-primary focus:border-primary focus:text-primary"
                  >
                    Đăng nhập bằng OTP
                  </Button>
                </Form.Item>
              </div>
              <Button
                className="login-sso-only mx-auto w-full p-[16px] bg-white rounded-[10px] font-semibold text-primary hover:border-primary hover:text-primary focus:border-primary focus:text-primary"
                onClick={() => {
                  const casLoginUrl = SsoURL.casLoginUrl;
                  const serviceUrl = SsoURL.casServiceUrl;
                  window.location.href = `${casLoginUrl}/login?service=${encodeURIComponent(serviceUrl)}`;
                }}
              >
                Đăng nhập bằng SSO
              </Button>
              <div className="text-primary text-center underline text-[16px] mt-5">
                Cần trợ giúp?
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="absolute left-0 right-0 bottom-0 text-center bg-primary text-white ">
        Tập đoàn công nghiệp - Viễn thông quân đội
      </div>
    </div>
  );
};

export default LoginPage;
